const persistentAdobeTaggingKeys = [
    'adobeAccount',
    'googleAccount',
    'targetCode',
    'pageName',
    'pageType',
    'loginStatus',
    'vehicleModel',
    'vehicleId',
    'dealerId',
    'vehicleCategory',
    'screenSize',
    'customerId',
    'countryCode',
    'languageCode',
    'testDriveDealerId',
    'testDriveDealerLocationLat',
    'testDriveDealerLocationLong',
    'testDriveDealerTradingName',
    'testDriveLeadId',
    'testDriveVehicleModelCode',
    'testDriveVehicleModelName',
    'offerCount',
    'formCount',
    'userLocation',
    'configuratorVersion',
    'mboxActivated',
    'registrationId',
    'inventoryId',
    'monthlyPrice',
    'eim',
    'navigationStep',
];

export default persistentAdobeTaggingKeys;
